export const PAYIX_ENDPOINTS = {
  card: '/app/web/nls/5/create-card-payment-token',
  ach: '/web/nls/create-ach-payment-token',
  both: '/app/web/nls/5/create-payment-token',
};

export function extractOrigin(url) {
  if (!url) return null;
  try {
    return new URL(url).origin;
  } catch {
    return url;
  }
}

export function buildIframeUrl({ baseUrl, accountNumber, paymentType = 'card', channel = 'web', lang = 'EN' }) {
  if (!baseUrl || !accountNumber) return null;
  const endpoint = PAYIX_ENDPOINTS[paymentType] || PAYIX_ENDPOINTS.card;
  const url = new URL(endpoint, baseUrl);
  url.searchParams.set('account', accountNumber);
  url.searchParams.set('channel', channel);
  url.searchParams.set('lang', lang);
  return url.toString();
}

function isTruthy(v) {
  return v === true || v === 'true' || v === 'True' || v === 'TRUE';
}

function isFalsy(v) {
  return v === false || v === 'false' || v === 'False' || v === 'FALSE';
}

function isSuccess(data) {
  return isTruthy(data?.status) || isTruthy(data?.Status);
}

function isFailure(data) {
  return isFalsy(data?.status) || isFalsy(data?.Status);
}

export const PAYIX_RESPONSE_KINDS = {
  SUCCESS: 'success',
  FAILURE: 'failure',
  UNKNOWN: 'unknown',
};

export function parsePayixResponse(data) {
  if (!data || typeof data !== 'object') {
    return { kind: PAYIX_RESPONSE_KINDS.UNKNOWN };
  }
  if (isSuccess(data)) {
    const token = data.token ?? data.Token;
    if (!token) {
      return {
        kind: PAYIX_RESPONSE_KINDS.FAILURE,
        message: 'Token creation succeeded but no token value was returned',
      };
    }
    return {
      kind: PAYIX_RESPONSE_KINDS.SUCCESS,
      token: {
        status: true,
        token,
        lastFourDigits: data.lastFourDigits ?? data.LastFourDigits,
        // Card-specific
        cardBrand: data.cardBrand ?? data.CardBrand,
        bin: data.bin ?? data.Bin,
        expiryDate: data.expiryDate ?? data.ExpiryDate,
        nameOnCard: data.nameOnCard ?? data.NameOnCard,
        billingZip: data.billingZip ?? data.BillingZip,
        // ACH-specific
        bankName: data.bankName ?? data.BankName,
        nameOnAch: data.nameOnAch ?? data.NameOnAch,
      },
    };
  }
  if (isFailure(data)) {
    return {
      kind: PAYIX_RESPONSE_KINDS.FAILURE,
      message: data.message ?? data.Message ?? 'Token creation failed',
    };
  }
  return { kind: PAYIX_RESPONSE_KINDS.UNKNOWN };
}
